export default [
  "turn",
  "move",
  "left",
  "right",

  "forward",
  "back",

  "arc",

  "fillText",
  "strokeText",
  "fillCanvas",
  "clear",

  "penUp",
  "penDown",

  "setStrokeStyle",
  "setStrokeColorRGB",
  "setStrokeColorHSL",
  "setFillStyle",
  "setStrokeActive",
  "setLineWidth",
  "setLineJoin",
  "setSpeed",
  "setImage",
  "setIcon",
  "setFont",
  "setTextAlign",
  "setTextBaseline",

  "setPosition",
  "resetPosition",
  "setInitialPosition",
  "setInitialRotation",

  "beginPath",
  "closePath",
  "fill",
  "stroke",
  "setLineCap",
  "setSize",
  "sleep",
  "eval",
];
